import React from 'react';
import { formatUnits, Hash } from 'viem';
import { SupportedChainId } from '@packet/constants/AppSupportChains';
import { useTokenInfo } from '@/hooks/useTokenInfo';
import { formatAmount } from '@/utils/amount';
import { Tooltip } from 'antd';

interface AssetAmountProps {
  assetId: Hash;
  chainId: SupportedChainId;
  amount: bigint | string | number;
  displayDigits?: number;
}

const AssetAmount: React.FC<AssetAmountProps> = ({ assetId, chainId, amount, displayDigits = -1 }) => {
  const { tokenInfo, loading, error } = useTokenInfo(assetId, chainId);

  if (loading) {
    return <>...</>;
  }

  if (error || !tokenInfo) {
    return <>--</>;
  }

  const amountStr = formatUnits(BigInt(amount), tokenInfo.decimals);

  if (displayDigits !== -1) {
    return <Tooltip title={amountStr}>{formatAmount(amountStr, displayDigits)}</Tooltip>;
  } else {
    return <>{amountStr}</>;
  }
};

export default AssetAmount;
